$(document).ready(function() {
    console.log('dsnvjksdnv');

    function toggleAccordionVisibility() {
        if (window.innerWidth > 768) {
            // Show the accordion content when the screen is wider than 768px
            $('.footer-accordion-content').show();
            $('.footer-updown-accordion-icon').removeClass('updown-accordion-icon-show');
        } else {
            // Hide the accordion content initially when the screen is smaller than 768px
            $('.footer-accordion-content').hide();
            $('.footer-updown-accordion-icon').removeClass('updown-accordion-icon-show');
        }
    }

    // Run on document ready
    toggleAccordionVisibility();

    // Also run on window resize
    $(window).resize(function() {
        toggleAccordionVisibility();
    });

    // Accordion toggle logic for screens less than 768px
    $(document).on('click', '.footer-link-title', function() {
        if (window.innerWidth < 768) {
            if ($(this).next('.footer-accordion-content').is(':visible')) {
                $(this).next('.footer-accordion-content').slideUp(300);
                $(this).find('.footer-updown-accordion-icon').removeClass('updown-accordion-icon-show');
            } else {
                $(this).next('.footer-accordion-content').slideDown(300);
                $(this).find('.footer-updown-accordion-icon').addClass('updown-accordion-icon-show');
            }
        }
    });
});
